import type {NoteDefinition, NoteProgress, SectionProgress} from './types';

export const evaluateProgress = <S, A>(
  definition: NoteDefinition<S, A>,
  state: S,
): NoteProgress => {
  const sections: Record<string, SectionProgress> = {};

  Object.entries(definition.sections).forEach(([id, section]) => {
    const visible = section.visible(state);
    sections[id] = {
      visible,
      complete:
        !visible || section.required(state).every(({complete}) => complete),
    };
  });

  return {
    sections,
    complete: Object.values(sections).every(({complete}) => complete),
  };
};
